package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import com.eladfinish.bible.contest.navigation.ViewContentTabsScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.screenKey
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersAction
import com.eladfinish.bible.contest.ui.menus.actions.ChapterContentToolbarAction
import com.eladfinish.bible.contest.ui.menus.viewModels.ToolbarActionBusViewModel

@Composable
internal fun ChapterContentToolbarBindings(
    onAction: (BrowseChaptersAction) -> Unit,
    toolbarActionBus: ToolbarActionBusViewModel,
) {
    val screenKey = ViewContentTabsScreenNavigationDestination::class.screenKey

    val onDispatch by rememberUpdatedState<(ChapterContentToolbarAction) -> Unit> { action ->
        onAction(BrowseChaptersAction.ToolbarClicked(toolbarAction = action))
    }

    LaunchedEffect(screenKey) {
        toolbarActionBus.setActiveScreenKey(screenKey)
        toolbarActionBus.events.collect { event ->
            if (event.screenKey != screenKey) return@collect
            val action = event.action as? ChapterContentToolbarAction ?: return@collect
            onDispatch(action)
        }
    }
}
